window.renderExternalIco = ((e) => {
  // noopener noreferrer
  setTimeout((e) => {
    $externals = $('.external');
    for (var i = 0; i < $externals.length; i++) {
      var $el = $($externals[i]);
      if ($el.attr('target') !== '_blank') {
        if ($el.hasClass('no-ico')) {
          $el.attr('target', '_blank').attr('rel', 'noopener');
        } else {
          $el.append('&nbsp;<i class="fas fa-external-link-alt fs-smaller"></i>')
            .attr('target', '_blank')
            .attr('rel', 'noopener');
        }
      }
    }
    $externals = $('.external-pdf');
    for (var i = 0; i < $externals.length; i++) {
      var $el = $($externals[i]);
      if ($el.attr('target') !== '_blank') {
        $el.prepend('<i class="fas fa-file-pdf fs-smaller text-danger ml-1"></i>&nbsp;')
          .attr('target', '_blank')
          .attr('rel', 'noopener');
      }
    }
  }, 100);
});

$(() => {
  renderExternalIco();
});